module.exports = __webpack_public_path__ + "static/media/logo-white.64ad6e44.png";